import * as React from "react";

export const MegamenuOverlay = ({ settings, type = 'darken'}) => {
    const overlayEffectValue = settings?.settings.effect_size;
    const effectClass = settings?.settings.mask === "darken" ? `bg-black` : ``;
    const effectStyle = settings?.settings.mask === "darken"
        ? { opacity: overlayEffectValue / 100 }
        : overlayEffectValue > 0
            ? { backdropFilter: `blur(${overlayEffectValue}px)` }
            : {}; // No style applied if overlayEffectValue is 0

    return (
        <>
            {settings.settings.mask != 'none' && <div className={`megamenu-overlay type-${settings?.settings.mask} ${effectClass}`} style={effectStyle}></div>}
        </>
    );
};
